module.exports = __webpack_public_path__ + "img/value-bededicated.1d5e14b4.svg";